import React from "react";
import { MapReportTitle } from "../mapSchema";
import { EventRecorderMicroProcessorSchema } from "./Schema";
import ReportTableSectionRenderer from "../../../../../libraries/ReportGenerator";
import { getSupportingDocuments } from "../../AirBrakeReports/AirBrakeReports/CommonFunctions";
const titleOfReport = (testCode) => MapReportTitle[testCode];
function EventRecorderMicroProcessorReport(props) {
  const { singleReport } = props;
  return (
    <div>
      <span className="spacer"></span>
      <div style={{ textAlign: "center" }}>
        <h2 style={{ fontWeight: "bolder" }}>{titleOfReport(singleReport.testCode) || singleReport.title}</h2>
      </div>
      <table className="table-bordered">
        {EventRecorderMicroProcessorSchema.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      {Object.keys(singleReport.summary).includes("supportingDocuments") && getSupportingDocuments(singleReport.summary)}
    </div>
  );
}

export default EventRecorderMicroProcessorReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/Periodic/EventRecorderMicroProcessor/index.jsx